import $ from "jquery";

const heroBannerOffset = () => {
  const el = {
    header: ".elementor[data-elementor-type='header']",
    wpadminbar: "#wpadminbar",
    heroBanner: "#hero_banner",
  };

  const init = () => {
    document.addEventListener("DOMContentLoaded", function () {
      if (null !== document.querySelector(el.heroBanner)) exec();

      $(window).on("resize", function () {
        exec();
      });
    });
  };

  const exec = () => {
    let headerHeight = $(el.header).height();

    if ($(el.wpadminbar).length) {
      headerHeight += $(el.wpadminbar).height();
    }

    $(el.heroBanner).css({ marginTop: `-${headerHeight}px` });
  };

  init();
};

try {
  heroBannerOffset();
} catch (error) {
  console.error(error);
}
